module.exports = __webpack_public_path__ + "6de79ec82396e3677975ef8936888d01.svg";